import Vue from 'vue'
import moment from 'moment'
import { number_to_text } from '@/thirdParty/convert_money_string'
import last from 'lodash/last'
// import { formatNumberV2 } from '@/thirdParty/format_number'

const daysOfWeek = {
  CN: 'Chủ nhật',
  T2: 'Thứ 2',
  T3: 'Thứ 3',
  T4: 'Thứ 4',
  T5: 'Thứ 5',
  T6: 'Thứ 6',
  T7: 'Thứ 7'
}

Vue.filter('encryptPhone', phoneNumber => {
  const visibleDigits = 3;
  if((phoneNumber?.length || 0) <= visibleDigits * 2) return phoneNumber || '';
  const asterisks = (phoneNumber?.length || 0) - (visibleDigits * 2);
  const prefix = phoneNumber.substr(0, visibleDigits);
  const suffix = phoneNumber.substr(-visibleDigits);
  const convertedNumber = prefix + "*".repeat(asterisks) + suffix;
  return convertedNumber;
})
Vue.filter('last', data => {
  return last(data)
})
// Vue.filter('formatDatePicker', date => {
//   if (!date) return
//   return moment(date).format('DD/MM/YYYY')
// })

// Vue.filter('formatDateTime', date => {
//   if (!date) return
//   return moment(date).format('DD/MM/YYYY HH:mm:ss')
// })

// Vue.filter('formatDateTime1', date => {
//   if (!date) return '--:--'
//   return moment(date).format('HH:mm DD/MM/YYYY')
// })

// Vue.filter('formatDateTime2', date => {
//   if (!date) return '--:--'
//   return moment(date).format('HH:mm A')
// })

// Vue.filter('formatDateTime3', date => {
//   if (!date) return '--:--'
//   return moment(date).format('HH:mm:00')
// })

// Vue.filter('formatDateTime4', date => {
//   if (!date) return '--:--'
//   return moment(date).format('HH:mm:ss DD/MM/YYYY')
// })

// Vue.filter('formatDateTime5', (date) => {
//   if (!date) return
//   const ms = moment(date).valueOf()
//   return moment(ms).format('hh:mm:ss DD/MM/YYYY')
// })

// Vue.filter('formatDateTime6', date => {
//   if (!date) return '--:--'
//   return moment.utc(date).format('DD/MM/YYYY HH:mm:ss')
// })

// Vue.filter('formatDateTime7', (date) => {
//   if (!date) return '--:--'
//   const ms = moment(date).valueOf()
//   return moment(ms).format('HH:mm, DD/MM/YYYY')
// })

// Vue.filter('formatDateTime8', date => {
//   if (!date) return
//   return moment(date).format('DD/MM/YYYY HH:mm')
// })

Vue.filter('formatDate', (value, format = 'DD/MM/YYYY') => {
  return value ? moment(value).format(format) : ''
})

// Vue.filter('formatMonthDate', date => {
//   if (!date) return
//   return moment(date).format('MM-DD-YYYY')
// })

// Vue.filter('formatHour', date => {
//   if (!date) return
//   return moment(date).format('HH:mm')
// })

Vue.filter('formatDate1', date => {
  return date?.substring(0, 10)
})

Vue.filter('formatHour1', date => {
  return date?.substring(10, 16)
})

// Vue.filter('formatDateDay', date => {
//   if (!date) return
//   return moment(date).format('DD')
// })

// Vue.filter('formatDateMonth', date => {
//   if (!date) return
//   return moment(date).format('MM')
// })

// Vue.filter('formatDateYear', date => {
//   if (!date) return
//   return moment(date).format('YYYY')
// })

Vue.filter('formatDay', date => {
  return daysOfWeek[date]
})

Vue.filter('mapStatus', (data) => {
  if (!data) return
  if (data === 'APPLYING') {
    return 'Đang áp dụng'
  }
  if (data === 'BLOCKED') {
    return 'Đã khoá'
  }
})

Vue.filter('mapTypeTime', (data) => {
  if (!data) return
  if (data === 'HOURS') {
    return 'giờ'
  }
  if (data === 'MINUTES') {
    return 'phút'
  }
  if (data === 'DAYS') {
    return 'ngày'
  }
  if (data === 'MONTHS') {
    return 'tháng'
  }
})

Vue.filter('placeHolder', data => {
  return data || 'null'
})

Vue.filter('fomatCurrency', currency => {
  return Number(currency).toLocaleString('vi-VI', {
    style: 'currency',
    currency: 'VND'
  })
})

Vue.filter('formatPriceToText', data => {
  if (!data) return 'không'
  return number_to_text(data)
})

Vue.filter('fomatCustomtype', (type) => {
  if (type === 'HOUSEHOLD') return 'Hộ kinh doanh'
  if (type === 'COMPANY') return 'Doanh nghiệp'
  if (type === 'INDIVIDUAL') return 'Cá nhân'
})
Vue.filter('fomatReason', (type) => {
  if (type === 'SOFTWARE_DEVICE') return 'Hoàn tiền thiết bị/phần mềm'
  if (type === 'RENT_LEND') return 'Hoàn tiền cọc cho thuê/cho mượn'
  if (type === 'CONTRACT_COINCIDENCE') return 'Hoàn tiền do thanh toán trùng hợp đồng'
})

Vue.filter('mapContractype', (data) => {
  if (!data) return
  if (data === 'READER') {
    return 'Thiết bị'
  }
  if (data === 'PAYMENT') {
    return 'Thanh toán'
  }
  if (data === 'INSTALLMENT') {
    return 'Trả góp'
  }
  if (data === 'QRCODE') {
    return 'QRCode'
  }
  if (data === 'OTHER') {
    return 'Khác'
  }
})

Vue.filter('mapTypeAppendix', (data) => {
  if (!data) return
  if (data === 'DEVICE') {
    return 'Thiết bị'
  }
  if (data === 'PAYMENT') {
    return 'Thanh toán'
  }
  if (data === 'INSTALLMENT') {
    return 'Trả góp'
  }
  if (data === 'QRCODE') {
    return 'QRCode'
  }
  if (data === 'OTHER') {
    return 'Khác'
  }
})

Vue.filter('mapdepositType', (data) => {
  if (!data) return
  if (data === 'BAN') {
    return 'Bán'
  }
  if (data === 'DAT_COC') {
    return 'Đặt cọc'
  }
})

Vue.filter('formatDirection', (data) => {
  if (data === 'outbound') return 'Gọi đi'
  if (data === 'inbound') return 'Gọi đến'
})

Vue.filter('mapTextTypeChange', (value) => {
  if (!value) return
  if (value === 'INFOR1') {
    return 'Đổi thông tin thanh toán, người đại diện'
  }
  if (value === 'INFOR2') {
    return 'Đổi thông tin Email và địa chỉ thanh toán'
  }
})

Vue.filter('mapAppenixFee', (data) => {
  if (!data) return
  if (data === 'DEVICE') {
    return 'Phụ lục thiết bị'
  }
  if (data === 'CREDIT') {
    return 'Phụ lục trả góp'
  }
  if (data === 'TRANS') {
    return 'Phụ lục giao dịch'
  }
  if (data === 'CHANGE') {
    return 'Phụ lục thay đổi thông tin'
  }
})

Vue.filter('fomatSaleType', (type) => {
  switch (type) {
    case 'REGION_DIRECTOR':
      return 'Giám đốc vùng'
    case 'SALE_MANAGER':
      return 'Sale Manager'
    case 'SALE_LEADER':
      return 'Sale Leader'
    case 'AFTER_SALE_LEADER':
      return 'After Sale Leader'
    case 'TELESALE_LEADER':
      return 'Telesale Leader'
    case 'SALE':
      return 'Sale Man'
    case 'SALE_ADMIN':
      return 'Sale Admin'
    case 'AFTER_SALE':
      return 'After Sale'
    case 'TELESALE':
      return 'Telesale'
    case 'KEY_ACCOUNT':
      return 'Kế toán'
    default:
      return 'Không xác định'
  }
})

Vue.filter('getNamePDF', (url) => {
  const uri_dec = decodeURIComponent(url)
  if (uri_dec.includes('PDF')) {
    const start = uri_dec.indexOf('PDF/')
    return uri_dec.substring(start + 4)
  }
  if (uri_dec.includes('file')) {
    const start = uri_dec.indexOf('file/')
    return uri_dec.substring(start + 5)
  }
})
Vue.filter('findObj', (data, items) => {
  return items?.[data] ?? ''
})
Vue.filter('findIdText', (data, items) => {
  return items?.find((e) => e.id === data)?.text ?? ''
})
Vue.filter('findCodeName', (data, items) => {
  return items?.find((e) => e.code === data)?.name ?? ''
})

Vue.filter('transformData', (data, dataListRole) => {
  const dataFilter = dataListRole.filter((e) => e.id === data)
  if (dataFilter.length === 0) {
    return ''
  }
  return dataFilter[0].text
})

Vue.filter('transfromMccName', (data, dataConfigMcc) => {
  const dataFilter = dataConfigMcc.filter((e) => e.code === data)
  if (dataFilter.length === 0) {
    return ''
  }
  return dataFilter[0].name
})

Vue.filter('transfromRegion', (data, dataConfigRegion) => {
  const dataReturn = dataConfigRegion.filter((e) => e.id === data)
  if (dataReturn.length === 0) {
    return ''
  }
  return dataReturn[0].text
})

Vue.filter('transfromData', (data, dataListRole) => {
  return dataListRole.find((e) => e.id === data)?.text ?? ''
})

Vue.filter('transfromCat', (data, dataConfigPurposes) => {
  const dataFilter = dataConfigPurposes.filter((e) => e.id === data)
  if (dataFilter.length === 0) {
    return ''
  }
  return dataFilter[0].text
})

Vue.filter('fomatStatus', (status, listStatus) => {
  const dataFilter = listStatus.filter((e) => e.id === status)
  return dataFilter[0].text
})

Vue.filter('transfromStatusCat', (data, purposesStatus) => {
  const dataFilter = purposesStatus.filter((e) => e.code === data)
  if (dataFilter.length === 0) {
    return ''
  }
  return dataFilter[0].text
})

Vue.filter('mapA', (period, list) => {
  const rate = list.find(s => s.period === period)?.rate
  return  rate ? rate + '%' : '-'
})

Vue.filter('formatDateHHMM', value => {
  if (!value) return
  return moment(value).format('HH:mm:ss DD/MM/YYYY')
})

Vue.filter('formatDateHHMM00', value => {
  if (!value) return
  return moment(value).format('HH:mm:00 DD/MM/YYYY')
})

Vue.filter('formatDay', value => {
  return daysOfWeek[value]
})

Vue.filter('fomatSaleType', value => {
  if (!value) return
  switch (value) {
    case 'REGION_DIRECTOR':
      return 'Giám đốc vùng'
    case 'SALE_MANAGER':
      return 'Sale Manager'
    case 'SALE_LEADER':
      return 'Sale Leader'
    case 'AFTER_SALE_LEADER':
      return 'After Sale Leader'
    case 'TELESALE_LEADER':
      return 'Telesale Leader'
    case 'SALE':
      return 'Sale Man'
    case 'SALE_ADMIN':
      return 'Sale Admin'
    case 'AFTER_SALE':
      return 'After Sale'
    case 'TELESALE':
      return 'Telesale'
    case 'KEY_ACCOUNT':
      return 'Kế toán'
    default:
      return 'Không xác định'
  }
})

Vue.filter('fomatTypeAddtionalKepping', value => {
  if (!value) return
  switch (value) {
    case 'TAKE_LEAVE':
      return 'Nghỉ phép'
    case 'ATTN_ADD':
      return 'Chấm công bổ sung'
    case 'VACATION_MODE':
      return 'Nghỉ chế độ(Khám thai, hiếu, hỉ, vợ sinh,...)'
    case 'DEPARTMENT_POLICY':
      return 'Nghỉ theo chính sách bộ phận'
    default:
      return 'Không xác định'
  }
})

Vue.filter('mapDateStatus', value => {
  switch (value) {
    case 'NEW':
      return 'Ngày tạo'
    case 'WAITING_APPROVED_FEE':
      return 'Ngày tạo'
    case 'APPROVED_FEE':
      return 'Ngày tạo'
    case 'SENT':
      return 'Ngày tạo'
    case 'WAITING_SIGN':
      return 'Ngày tạo'
    case 'SIGNING':
      return 'Ngày tạo'
    case 'SIGNED_MISS_IMAGE':
      return 'Ngày ký'
    case 'SIGNED':
      return 'Ngày ký'
    case 'SIGNED_WAITING_APPROVED':
      return 'Ngày ký'
    case 'APPROVED':
      return 'Ngày ký'
    case 'REJECTED_SA':
      return 'Ngày ký'
    case 'REJECTED_MC':
      return 'Ngày tạo'
    case 'REJECTED_MA':
      return 'Ngày tạo'
    case 'CANCELED':
      return 'Ngày hủy'
    default:
      return 'Không xác định'
  }
})
Vue.filter('fomatStatusTextAdd', value => {
  if (!value) return
  switch (value) {
    case 'NEW':
      return 'Mới tạo'
    case 'WAITING':
      return 'Chờ duyệt'
    case 'DENIED':
      return 'Đã hủy'
    case 'APRROVED':
      return 'Đã duyệt'
    case 'NOT_ACCEPT':
      return 'Không chấp nhận'
    case 'ACCEPT':
      return 'Chấp nhận'
    default:
      return 'Không xác định'
  }
})
Vue.filter('fomatResultNameAFS', value => {
  if (!value) return
  switch (value) {
    case 'SUCCESS':
      return 'Thành công'
    case 'FAILED':
      return 'Thất bại'
    case 'OTHERS':
      return 'Khác'
  }
})

Vue.filter('fomatTypeHistory', value => {
  if (!value) return
  switch (value) {
    case 'HISTORY_APPROVED_FEE':
      return 'Duyệt phí'
    case 'HISTORY_APPROVED':
      return 'Duyệt'
    case 'PAPER_ACTION_APPROVE':
      return 'Duyệt'
    case 'HISTORY_REJECTED_MA':
      return 'MA từ chối'
    case 'HISTORY_REJECTED_SA':
      return 'SA từ chối'
    case 'HISTORY_ADDITIONAL':
      return 'Cần bổ sung'
    case 'PAPER_ACTION_ADD_INFO':
      return 'Cần bổ sung'
    case 'HISTORY_APPROVED_COLLABORATOR':
      return 'GS Duyệt trả hoa hồng'
    case 'HISTORY_REJECTED_COLLABORATOR':
      return 'GS Từ chối trả hoa hồng'
    case 'HISTORY_IMG_UPDATE':
      return 'Lịch sử sửa ảnh'
    case 'HISTORY_ROLLBACK':
      return 'Lịch sử chuyển chờ duyệt'
    default:
      return value
  }
})
Vue.filter('fomatCreatorAFS', value => {
  if (!value) return
  switch (value) {
    case 'MERCHANT':
      return 'Merchant'
    case 'SALES':
      return 'Sales'
    case 'OPERATOR':
      return 'Vận hành'
    case 'MANAGER':
      return 'Quản lý'
    case 'OTHER':
      return 'Khác'
    default:
      return 'Khác'
  }
})
Vue.filter('fomatCreatoByAFS', value => {
  if (!value) return
  switch (value) {
    case 'CALL':
      return 'Gọi điện'
    case 'MESSAGE':
      return 'Tin nhắn'
    case 'CHAT':
      return 'Trò chuyện'
    case 'CHECK':
      return 'Kiểm tra merchant'
    case 'EMAIL':
      return 'Email'
    case 'HOT_LINE':
      return 'Đường dây nóng'
    default:
      return 'Khác'
  }
})

Vue.filter('mapTextStatus', (data, listState) => {
  if (!data) return
  const text = listState.filter((e) => e.id === data)
  return text.length > 0 ? text[0].text : ''
})

Vue.filter('resultCall', (data, resultStatusCalls) => {
  const response = resultStatusCalls.find((e) => e.code === data)
  return response ? response.value : null
})

Vue.filter('fomatTextService', (data, listSerive) => {
  if (!data || !listSerive) return null
  const dataReturn = listSerive.find(e => e.service === data)
  if (dataReturn) return dataReturn.name
})

Vue.filter('transformNumber', (data) => {
  return data ? data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : 0
})

Vue.filter('transformMoney', data => {
  return data ? data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : 0
})

Vue.filter('serviceType', (data) => {
  if (data === 'PAYMENT') return 'Thanh toán'
  if (data === 'SELL') return 'Bán hàng'
})

Vue.filter('packageService', (data) => {
  if (data === 'ONLY_SOFTWARE') return 'CHỈ CÓ PM'
  if (data === 'SOFTWARE_HARDWARE') return 'PM + PHẦN CỨNG (D3/PAL/PAC)'
  if (data === 'BASIC') return 'CƠ BẢN'
  if (data === 'PROFESSIONAL') return 'CHUYÊN NGHIỆP'
  if (data === 'PREMIUM') return 'CAO CẤP'
})

Vue.filter('statusKPI', (data) => {
  if (data === 'ACTIVE') return 'Đang hoạt động'
  if (data === 'INACTIVE') return 'Khóa'
})

Vue.filter('statusKPIOrders', (data) => {
  if (data === 'CONFIRMED') return 'Đã chốt'
  if (data === 'NOT_CONFIRM') return 'Chưa chốt'
})

Vue.filter('formatNum', data => {
  if (!data) return '0'
  // return formatNumberV2(data)
  const [int, dec] = Math.abs(num).toString().split('.');
  return `${num < 0 ? '-' : ''}${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${dec ? `,${dec}` : ''}`;
})
Vue.filter('checkEmpty', data => {
  return data ? data : ''
})

Vue.filter('formatNumberVN', value => {
  return typeof value === 'number' ? value.toLocaleString('vi-VN') : ''
})
